import React from 'react';
import Select from 'react-select';

import CriterionApi from '../../api/criterion';
import Message from '../form/Message';
import AuthService from '../../state/auth.service';

const CHECKIN_OPTIONS = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: 'Unplanned', value: 'Unplanned' },
];

class CheckinCard extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentCheckin: null,
            message: null,
            isUserAdmin: false,
        };

        this.updateCheckin = this.updateCheckin.bind(this);
    }

    componentDidMount() {
        let userRole = AuthService.getUser();
        if (userRole) {
            this.setState({
                isUserAdmin: userRole.role === 'Administrator' || userRole.role === 'Restricted',
            });
        } else this.setState({ isUserAdmin: false });
    }

    updateCheckin(newCheckin) {
        let checkinUpdate = { checkin: newCheckin.value };

        if (typeof this.props.onCriterionChange === 'function') {
            this.props.onCriterionChange(checkinUpdate);
        } else {
            CriterionApi.updateCheckin(
                this.props.criterion.id,
                newCheckin.value
            )
                .then(result => {
                    this.setState({
                        currentCheckin: result.checkin,
                    });
                })
                .catch(error => {
                    this.setState({
                        message: 'Unable to change checkin.',
                    });
                });
        }
    }

    render() {
        const criterion = this.props.criterion;
        let checkin = criterion.checkin || 'Unplanned';
        if (this.state.currentCheckin) {
            checkin = this.state.currentCheckin;
        }

        const adminSelect = (
            <Select
                name="checkin"
                disabled={criterion.status === 'Prevalidated' || this.props.disableCriterion}
                options={CHECKIN_OPTIONS}
                value={checkin}
                onChange={this.updateCheckin}
                clearable={false}
                searchable={false}
            />
        );

        const checkinStatus = <div className="statusText">{checkin}</div>;

        let statusContent = checkinStatus;
        if (this.state.isUserAdmin) {
            statusContent = adminSelect;
        }

        return (
            <div className="CheckinCard">
                <div>{statusContent}</div>
                <Message error={this.state.message} />
            </div>
        );
    }
}

export default CheckinCard;
